<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-文章-添加
    -->
  <div class="product-add pb50">
   <!--添加文章-->
    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">添加任务</div>
      <el-form-item label="任务标题" prop="title"><el-input v-model="form.title" placeholder="请输入任务标题" class="max-w460"></el-input></el-form-item>
      <el-form-item label="奖金类型">
        <el-radio-group v-model="form.type">
          <el-radio :label="'10'">金币</el-radio>
          <el-radio :label="'20'">购物金</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="奖金"><el-input type="number" v-model="form.bonus" placeholder="请输入数字" class="max-w460"></el-input></el-form-item>
      <el-form-item label="跳转地址" prop="url"><el-input v-model="form.url" placeholder="请输入跳转地址" class="max-w460"></el-input></el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import TaskApi from '@/api/task.js';
export default {
  data() {
    return {
      /*form表单数据*/
      form: {
        title: '',
        type: '10',
        bonus: 1,
        url: '',
      },
      loading: false,
      /*验证规则*/
      rules: {
        title: [{ required: true, message: '请输入任务标题', trigger: 'blur' }],
        url: [{ required: true, message: '请输入跳转地址', trigger: 'blur' }],
      }
    };
  },
  created() {

  },
  methods: {
    /*添加任务*/
    onSubmit() {
      let self = this;
      let form = self.form;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          TaskApi.addTask(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.$router.push('/plus/task/index');
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$router.push({
        path: '/plus/task/index'
      });
    }
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/task/task/add.vue